import { TerminalEvent } from './terminal-event.js'

/**
 * Resize event fired when the terminal window size changes.
 *
 * Triggered by the SIGWINCH signal or equivalent mechanism.
 */
export class ResizeEvent extends TerminalEvent {
	/** New terminal width in columns */
	readonly columns: number
	/** New terminal height in rows */
	readonly rows: number

	constructor(columns: number, rows: number) {
		super('resize', { bubbles: false, cancelable: false })
		this.columns = columns
		this.rows = rows
	}
}
